import {AppState} from '../AppState';

export const getCities = (state: AppState) => state.cities;
